var _link, _link2, _style, _style2, _style3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDisconnected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _link || (_link = /*#__PURE__*/React.createElement("link", {
    xmlns: "",
    type: "text/css",
    rel: "stylesheet",
    id: "dark-mode-custom-link"
  })), _link2 || (_link2 = /*#__PURE__*/React.createElement("link", {
    xmlns: "",
    type: "text/css",
    rel: "stylesheet",
    id: "dark-mode-general-link"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    lang: "en",
    type: "text/css",
    id: "dark-mode-custom-style"
  })), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    lang: "en",
    type: "text/css",
    id: "dark-mode-native-style"
  })), _style3 || (_style3 = /*#__PURE__*/React.createElement("style", {
    xmlns: "",
    lang: "en",
    type: "text/css",
    id: "dark-mode-native-sheet"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "lightgray",
    style: {
      lineHeight: "normal",
      textIndent: 0,
      textAlign: "start",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textDecorationColor: "#BBB",
      textTransform: "none",
      blockProgression: "tb",
      isolation: "auto",
      mixBlendMode: "normal"
    },
    d: "M 14.646484 0.64648438 L 13.158203 2.1347656 L 12.839844 1.8164062 C 12.296365 1.2735345 11.580834 1.0019438 10.865234 1.0019531 C 10.149635 1.0019625 9.4336568 1.2753275 8.890625 1.8183594 L 7.7070312 3 L 7.3535156 2.6464844 L 6.6464844 3.3535156 L 8.2929688 5 L 6.6464844 6.6464844 L 7.3535156 7.3535156 L 9 5.7070312 L 10.292969 7 L 8.6464844 8.6464844 L 9.3535156 9.3535156 L 11 7.7070312 L 12.646484 9.3535156 L 13.353516 8.6464844 L 13 8.2929688 L 14.183594 7.109375 C 15.269337 6.0224182 15.269657 4.2462199 14.183594 3.1601562 L 13.865234 2.8417969 L 15.353516 1.3535156 L 14.646484 0.64648438 z M 10.865234 1.9980469 C 11.322901 1.9980069 11.780292 2.1732625 12.132812 2.5253906 L 13.476562 3.8671875 C 14.180499 4.5711238 14.180819 5.6973005 13.476562 6.4023438 L 12.292969 7.5859375 L 8.4140625 3.7070312 L 9.5976562 2.5253906 C 9.9496247 2.1734225 10.407568 1.9980869 10.865234 1.9980469 z M 3.3535156 6.6464844 L 2.6464844 7.3535156 L 3 7.7070312 L 1.8164062 8.890625 C 0.73066262 9.9775818 0.73034267 11.75378 1.8164062 12.839844 L 2.1347656 13.158203 L 0.64648438 14.646484 L 1.3535156 15.353516 L 2.8417969 13.865234 L 3.1601562 14.183594 C 4.2471132 15.269337 6.0233113 15.267751 7.109375 14.181641 L 8.2929688 13 L 8.6464844 13.353516 L 9.3535156 12.646484 L 3.3535156 6.6464844 z M 3.7070312 8.4140625 L 7.5859375 12.292969 L 6.4023438 13.474609 C 5.6984074 14.178546 4.5722307 14.178866 3.8671875 13.474609 L 2.5234375 12.132812 C 1.8195012 11.428877 1.8191812 10.302699 2.5234375 9.5976562 L 3.7070312 8.4140625 z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnected);
export default __webpack_public_path__ + "static/media/disconnected.18ca22879f95b7e143a261e578628c48.svg";
export { ForwardRef as ReactComponent };